/**
 * Wrap article body tables in a horizontal scroll container so only the table scrolls,
 * not the whole article column (avoids full-column sideways drift on mobile).
 */
(function () {
  'use strict';

  function run() {
    var root = document.getElementById('blog-article-body');
    if (!root) return;

    var tables = root.querySelectorAll('table');
    for (var i = 0; i < tables.length; i++) {
      var table = tables[i];
      if (table.closest('[data-component="inline-product-card"]')) continue;
      var parent = table.parentElement;
      if (parent && parent.classList.contains('article-table-scroll')) continue;

      var wrap = document.createElement('div');
      wrap.className = 'article-table-scroll';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', 'Table');

      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
